import type { IncidentFieldRule } from './types';

export const supplierPerformanceFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What kind of supplier performance issue is this?',
        description: 'Select the type of supplier performance issue.',
        order: 90,
    },
    {
        key: 'supplierName',
        label: 'Which supplier is involved?',
        description: 'Enter the full name of the supplier.',
        order: 100,
    },
    {
        key: 'natureOfPerformanceIssue',
        label: 'What is the performance issue?',
        description: 'Describe the failure, e.g. delayed delivery, quality defect.',
        kind: 'textarea',
        order: 110,
    },
    {
        key: 'supplierNotified',
        label: 'Has the supplier been notified?',
        description: 'Select Yes if the supplier has been informed about the incident.',
        order: 120,
    },
    {
        key: 'impactOnCustomerDeliveryOrService',
        label: 'Did this impact customer delivery or service?',
        description: 'Select Yes if the supplier issue affected customer-facing services.',
        order: 130,
    },
    {
        key: 'sLAReference',
        label: 'Relevant SLA reference',
        description: 'Enter the relevant SLA or contract reference number.',
        order: 140,
    },
];
